module.exports = __webpack_public_path__ + "img/selected5-min.b24dfe8e.png";